import React from "react";

/**
 * @component ClockDollarIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 *
 * @example
 * return (
 *   <ClockDollarIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const ClockDollarIcon = React.forwardRef(
  (props: React.SVGProps<SVGSVGElement>, svgRef?: React.Ref<SVGSVGElement>) => (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="ClockDollarIcon"
      fill="var(--color-theme-600)"
      focusable={false}
      ref={svgRef}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10h-2a8 8 0 10-8 8v2C6.477 22 2 17.523 2 12zm9-6v4.999L6 11v2h7V6h-2z"
      />
      <path d="M19 23h-2v-1h-2v-2h4v-1h-3a1 1 0 01-1-1v-3a1 1 0 011-1h1v-1h2v1h2v2h-4v1h3a1 1 0 011 1v3a1 1 0 01-1 1h-1v1z" />
    </svg>
  )
);
ClockDollarIcon.displayName = "ClockDollarIcon";
export default ClockDollarIcon;
